import { render, staticRenderFns } from "./ChooseMeal.vue?vue&type=template&id=8e11a636&scoped=true&"
import script from "./ChooseMeal.vue?vue&type=script&lang=js&"
export * from "./ChooseMeal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseMeal.scss?vue&type=style&index=0&id=8e11a636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e11a636",
  null
  
)

export default component.exports